export const activitiesCall = [
  {
    id: 1,
    checkbox: "",
    title: "Had conversation with Fred regarding task",
    due_date: "29 Sep 2023, 04:12 pm",
    owner: "Monty Beer",
    created_date: "27 Sep 2023, 03:26 pm",
    status: "3",
    action: "",
	key: "1"
  },
  {
    id: 2,
    checkbox: "",
    title: "Call John and discuss about project",
    due_date: "12 Nov 2023, 10:20 pm",
    owner: "Itzel",
    created_date: "02 Nov 2023, 05:35 pm",
    status: "3",
    action: "",
	key: "2"
  },
  {
    id: 3,
    checkbox: "",
    title: "Discussed budget proposal with Edwin",
    due_date: "08 Dec 2023, 04:35 pm",
    owner: "Merwin",
    created_date: "01 Dec 2023, 10:45 am",
    status: "3",
    action: "",
	key: "3"
  },
  {
    id: 4,
    checkbox: "",
    title: "Discussed budget proposal with Edwin",
    due_date: "26 Dec 2023, 08:30 am",
    owner: "Clausen",
    created_date: "18 Dec 2023, 05:00 pm",
    status: "3",
    action: "",
	key: "4"
  },
];
